// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__29X9W","additionalInfo":"AgreementModal_additionalInfo__1ePPZ"};